const styles = {
  blueColor: "#005a76",
  lightBlueBgColor: "rgb(13 148 136)",
  greyColor: "#E9EDF1",
  orange: "#ff7222",
  badgeLightBlueBg: "#D9E7EB",
  hardBadgeLightBlueBg: "#86AFBB",
  yellow: "#FEE8D9",
  hardYellow: "#EAB544",
  pink: "#F4DEFB",
  hardPink: "#DFB3EC",
  red: "rgb(201, 1, 1)",
  green: "#00ff00",
  transparent: "transparent",
  buttonTeal: "#00b3b3",
  buttonTealHover: "#008e8e",
};

export default styles;
